import React, { useEffect, useRef } from 'react';
import { DS } from '../ds';
const items = [{
  icon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" data-id="element-195" data-mp="1pu8xsqfps3nv">
        <path d="M6.5 1L10 3V6C10 8.5 8.5 10.5 6.5 11.5C4.5 10.5 3 8.5 3 6V3L6.5 1Z" fill={`${DS.color.teal}22`} stroke={DS.color.teal} strokeWidth="1.1" strokeLinejoin="round" data-id="element-196" data-mp="1pwmqismx93s9" />
        <path d="M5 6.5L6 7.5L8.5 5" stroke={DS.color.teal} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-197" data-mp="124eo2hqoyv7u" />
      </svg>,
  label: 'Certificación INVIMA vigente',
  highlight: true
}, {
  icon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" data-id="element-198" data-mp="x5uwa0pf2p7k">
        <rect x="2" y="4" width="9" height="7" rx="1.2" stroke={DS.color.teal} strokeWidth="1.1" data-id="element-199" data-mp="x64o7tu0v6fw" />
        <path d="M4.5 4V3C4.5 1.9 5.4 1 6.5 1C7.6 1 8.5 1.9 8.5 3V4" stroke={DS.color.teal} strokeWidth="1.1" strokeLinecap="round" data-id="element-200" data-mp="2rikwf06doune" />
        <circle cx="6.5" cy="7.5" r="1" fill={DS.color.teal} data-id="element-201" data-mp="3lqkl4ahjso5o" />
      </svg>,
  label: 'Empaque personalizado por clínica',
  highlight: false
}, {
  icon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" data-id="element-202" data-mp="3vfvve0g67yv5">
        <circle cx="6.5" cy="6.5" r="5.5" stroke={DS.color.teal} strokeWidth="1.1" data-id="element-203" data-mp="3vhp3lk6fmr59" />
        <path d="M4 6.5L6 8.5L9.5 4.5" stroke={DS.color.teal} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-204" data-mp="37qjleyd0rmrs" />
      </svg>,
  label: 'Fabricación 100% colombiana',
  highlight: false
}, {
  icon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" data-id="element-205" data-mp="3cobh83gsbt19">
        <circle cx="6.5" cy="6.5" r="5.5" stroke={DS.color.teal} strokeWidth="1.1" data-id="element-206" data-mp="wxgs7ccguw26" />
        <path d="M6.5 3.5V6.5L8.5 8" stroke={DS.color.teal} strokeWidth="1.2" strokeLinecap="round" data-id="element-207" data-mp="rz5jx61tktm2" />
      </svg>,
  label: 'Respuesta en menos de 24h',
  highlight: false
}, {
  icon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" data-id="element-208" data-mp="13zlngy9c4zcg">
        <path d="M2 10L5 7L7.5 9.5L11 4" stroke={DS.color.teal} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-209" data-mp="18zzxumyesldn" />
      </svg>,
  label: 'Precisión ±0.1 mm por alineador',
  highlight: false
}, {
  icon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" data-id="element-210" data-mp="la5ncc1kb8wk">
        <path d="M6.5 1L10 3V6C10 8.5 8.5 10.5 6.5 11.5C4.5 10.5 3 8.5 3 6V3L6.5 1Z" fill={`${DS.color.teal}22`} stroke={DS.color.teal} strokeWidth="1.1" strokeLinejoin="round" data-id="element-211" data-mp="l8cc0jg080i8" />
        <path d="M5 6.5L6 7.5L8.5 5" stroke={DS.color.teal} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-212" data-mp="3tra5ol5s3i23" />
      </svg>,
  label: 'Sin contrato de exclusividad',
  highlight: false
}];

// Duplicamos para el loop infinito
const allItems = [...items, ...items, ...items];
export const AnnouncementBar = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let pos = 0;
    let raf: number;
    const speed = 0.5; // px por frame

    const animate = () => {
      pos -= speed;
      const totalWidth = track.scrollWidth / 3;
      if (Math.abs(pos) >= totalWidth) {
        pos = 0;
      }
      track.style.transform = `translateX(${pos}px)`;
      raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, []);
  return <div aria-label="Información institucional Alinova" style={{
    width: '100%',
    overflow: 'hidden',
    background: `linear-gradient(90deg, #E8F8F8 0%, #F0FAFA 50%, #E8F8F8 100%)`,
    borderBottom: `1px solid ${DS.color.aqua}30`,
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 10
  }} data-id="element-213" data-mp="1e53r8woxixfe">
      {/* Fade izquierda */}
      <div aria-hidden="true" style={{
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: '80px',
      background: 'linear-gradient(90deg, #E8F8F8, transparent)',
      zIndex: 2,
      pointerEvents: 'none'
    }} data-id="element-214" data-mp="2zhf9xvin1u4x" />

      {/* Track animado */}
      <div ref={trackRef} style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0',
      willChange: 'transform',
      whiteSpace: 'nowrap'
    }} data-id="element-215" data-mp="2vesd1g741j0v">
        {allItems.map((item, i) => <React.Fragment key={i} data-id="element-216" data-mp="etapn8491ra3" data-mpi={i}>
            <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '7px',
          padding: '0 24px',
          flexShrink: 0
        }} data-id="element-217" data-mp="eq505rrpkndu">
              {item.highlight ? <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '3px 12px 3px 8px',
            borderRadius: DS.radius.pill,
            background: `linear-gradient(135deg, ${DS.color.teal}18, ${DS.color.aqua}22)`,
            border: `1px solid ${DS.color.aqua}45`
          }} data-id="element-218" data-mp="1zbv0csqftwjl">
                  {item.icon}
                  <span style={{
              fontFamily: DS.font.body,
              fontSize: '12px',
              fontWeight: 700,
              color: DS.color.tealDeep,
              letterSpacing: '0.02em'
            }} data-id="element-219" data-mp="2wwpp8ag41lbx">
                    {item.label}
                  </span>
                </span> : <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px'
          }} data-id="element-220" data-mp="2xp0i31co9kfd">
                  {item.icon}
                  <span style={{
              fontFamily: DS.font.body,
              fontSize: '12px',
              fontWeight: 500,
              color: DS.color.body,
              letterSpacing: '0.01em'
            }} data-id="element-221" data-mp="3bmp5ogy4j5o4">
                    {item.label}
                  </span>
                </span>}
            </div>

            {/* Separador punto */}
            <span aria-hidden="true" style={{
          width: '4px',
          height: '4px',
          borderRadius: '50%',
          background: `${DS.color.aqua}50`,
          flexShrink: 0,
          display: 'inline-block'
        }} data-id="element-222" data-mp="3ucne4y5u30sa" />
          </React.Fragment>)}
      </div>

      {/* Fade derecha */}
      <div aria-hidden="true" style={{
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      width: '80px',
      background: 'linear-gradient(270deg, #E8F8F8, transparent)',
      zIndex: 2,
      pointerEvents: 'none'
    }} data-id="element-223" data-mp="d9r9p3n4voby" />
    </div>;
};